import { useEffect, useRef } from "react";
import { useSettings } from "../lib/settings";

function inject(el, code) {
  el.innerHTML = "";
  if (!code) return;
  const frag = document.createRange().createContextualFragment(code);
  el.appendChild(frag);
}

export function AdSlot({ name, className = "gg-ad" }) {
  const { ads } = useSettings();
  const code = ads?.[name] || "";
  const ref = useRef(null);
  useEffect(() => {
    if (ref.current) inject(ref.current, code);
  }, [code]);
  if (!code) return null;
  return <div ref={ref} className={className} data-testid={`ad-slot-${name}`} />;
}

export function HeadCode() {
  const { ads } = useSettings();
  const code = ads?.head_code || "";
  useEffect(() => {
    if (!code) return undefined;
    const holder = document.createElement("div");
    const frag = document.createRange().createContextualFragment(code);
    const nodes = Array.from(frag.childNodes);
    nodes.forEach((n) => document.head.appendChild(n));
    holder.remove();
    return () => nodes.forEach((n) => n.parentNode && n.parentNode.removeChild(n));
  }, [code]);
  return null;
}
